module.exports = __webpack_public_path__ + "media/media/product-card/video_prev-small-159fc689bb6476a15ba53f41499b1e10.jpg";